export const SETUP_GOALS = {
  MAXIMIZE_SPECIFIC_RISK: "maximizeSpecificRisk",
  TARGET_TOTAL_RISK: "targetTotalRisk",
  MIN_VOLATILITY: "minVolatility",
} as const

export const RULES_CONSTRAINTS = {
  TRADE_SWAPS: "tradeSwaps",
  MAX_TURNOVER: "maxTurnover",
  CONCENTRATION: "concentration",
  MAX_TRADE: "maxTrade",
  EQUITY_CHANGE: "equityChange",
  NET_LONG: "netLong",
  ALLOW_DIRECTION_CHANGE: "allowDirectionChange",
} as const

export type SetupGoal = (typeof SETUP_GOALS)[keyof typeof SETUP_GOALS]

export const FILTER_ACTIONS = {
  CREATE_CUSTOM_SEARCH: "create-custom-search",
} as const

export const FILTER_GROUPS = {
  SAVED_SEARCHES: "Saved Searches",
} as const

export const OPTIMIZATION_SOURCE_ORIGINAL_LABEL = "Original portfolio"
export const OPTIMIZATION_SOURCE_EXPERIMENT_LABEL = "Saved experiment"
export const PORTFOLIO_INPUT_HEADING = "Portfolio input"
export const OPTIMIZATION_INPUT_HEADING = "Optimization input"
export const INTRADAY_OPTIMIZATION_UNAVAILABLE_MESSAGE = "Optimization runs on end-of-day data. Set the end date to a previous day to optimize."
export const PORTFOLIO_INPUT_TOOLTIP_BASE =
  "Optimization uses the positions from the source you select below on the analysis date. Sketched or rebalanced trades are for comparison only unless you save them as an experiment and select that experiment here."
export const POSITION_SET_INPUT_TOOLTIP_BASE =
  "Optimization uses the positions from the selected instrument on the analysis date. Sketched or rebalanced trades are for comparison only."
export const OPTIMIZATION_SOURCE_HINT_PORTFOLIO =
  "Choose whether optimization starts from the original portfolio or a saved experiment for this portfolio."

export const MAX_TURNOVER_TOOLTIP = "Limits total trading across all names. Example: with a 20% cap, the optimizer can trade up to 20% of the portfolio’s value in total"
export const CONCENTRATION_TOOLTIP = (
  `Sets minimum and maximum position sizes as a percentage of equity (long or short), applied uniformly across all securities. 
  If it is not optimal to hold a given asset at the minimum weight, it will force the the single security to not be held at all`
)
export const MAX_TRADE_TOOLTIP = (
  `Caps the size of any individual trade based on liquidity and position limits. Example: A trade may be limited to 25% of average daily volume, 5% of portfolio equity,
  or 10% of the current position size. The most restrictive limit applies`
)
export const EQUITY_CHANGE_TOOLTIP = "Limits how much total equity value can change. Example: with a 3% cap, the portfolio’s equity value can move by at most 3% of equity"
export const NET_TOOLTIP = "Targets the portfolio’s net after optimization, showing the long / short split of gross"
export const TRADE_BASKETS_TOOLTIP = "This allows baskets to be treated as a security that can be traded, if any are held in this portfolio"
export const ALLOW_DIRECTION_CHANGE_TOOLTIP = "Honors a position’s long or short placement in the book. Change to true to allow changing a positions sign from long to short or short to long"
